export interface FocusEnvironment {
  windowEvents: EventTarget;
  documentEvents: EventTarget;
  isVisible(): boolean;
  hasFocus(): boolean;
}

/** Pauses before stepping when browser focus events arrive late or are coalesced. */
export class FocusPauseGuard {
  private readonly environment: FocusEnvironment;
  private readonly pause: () => void;
  private disposed = false;
  private readonly onBlur = (): void => {
    if (!this.disposed) this.pause();
  };
  private readonly onVisibilityChange = (): void => {
    if (!this.environment.isVisible()) this.onBlur();
  };

  constructor(environment: FocusEnvironment, pause: () => void) {
    this.environment = environment;
    this.pause = pause;
    environment.windowEvents.addEventListener('blur', this.onBlur);
    environment.documentEvents.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  check(): void {
    if (!this.environment.isVisible() || !this.environment.hasFocus()) this.onBlur();
  }

  dispose(): void {
    this.disposed = true;
    this.environment.windowEvents.removeEventListener('blur', this.onBlur);
    this.environment.documentEvents.removeEventListener(
      'visibilitychange',
      this.onVisibilityChange,
    );
  }
}
